import { Injectable } from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const MENUITEMS = [
  {
    label: 'Configuración',
    main: [
      {
        state: 'parameters',
        name: 'Parámetros',
        type: 'link',
        icon: 'ti-home'
      },
      {
        state: 'paymenttypes',
        name: 'Tipo de medios de pago',
        type: 'link',
        icon: 'ti-credit-card'
      },
      {
        state: 'organisms',
        name: 'Organismos',
        type: 'link',
        icon: 'ti-agenda'
      },
      {
        state: 'services',
        name: 'Servicios',
        type: 'link',
        icon: 'ti-book'
      },
      {
        state: 'qrhistory',
        name: 'Histórico lectura QR',
        type: 'link',
        icon: 'ti-layout-list-thumb'
      }
    ]
  }
];

@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    return MENUITEMS;
  }

  /*add(menu: Menu) {
      MENUITEMS.push(menu);
    }*/
}
